import { createSlice } from "@reduxjs/toolkit";
import apiManagerUser from "api/manager-users";
import { setShowBackdrop } from "store/commonSlice";
import store from "store/store";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerUser.getListPackage(data);
        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total_records
            }))
        } else {
            console.log("res: ", res);
        }
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
        store.dispatch(setShowBackdrop(false))
    }
}

export const fetchDataDetail = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerUser.getPackageDetail(data);
        if (res.status === 200) {
            store.dispatch(setTableDataDetail({
                data: res.data,
                total: res.total_records
            }))
        } else {
            console.log("res: ", res);
        }
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
        store.dispatch(setShowBackdrop(false))
    }
}

export const fetchDataMyUser = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerUser.getMyUserLicense(data);
        if (res.status === 200) {
            store.dispatch(setTableDataMyUser({
                data: res.data,
                total: res.total_records
            }))
        }
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    tableDataDetail: {
        data: [],
        total: 0
    },
    tableDataMyUser: {
        data: [],
        total: 0
    },
    searchQuery: {
        typeArr: ['main', 'addOns'],
        package_code: '',
        package_name: '',
        // page: 0,
        deployment_system_code:'ViettelMeetingCloud',
    },
    searchQueryDetail: {
        package_id: 0,
        status: ['valid', 'expired'],
        statusAssign: ['1', 'assigned'],
        license_code: '',
        nameOrEmail: '',
        deployment_system_code:'ViettelMeetingCloud'
    },
    searchQueryMyUser: {
        typeArr: ['main', 'addOns'],
        statusArr: ['sent', 'joined'],
        license_code: '',
        package_name:'',
        nameOrEmail: ''
    },
    listAssign: [],
    isResponse : true,
    emailAssign: "",
    namePackageAssign: "",
    licenseCodeAssign: "",
    emailCurrentAction: '',
    namePackage: '',
    isRefresh: false,
    isLoading: false,
}

export const packageManagementSlice = createSlice({
    name: 'packageManagement',
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setTableDataDetail: (state, action) => void (state.tableDataDetail = action.payload),
        setTableDataMyUser: (state, action) => void (state.tableDataMyUser = action.payload),
        setSearchQuery: (state, action) => void(state.searchQuery = action.payload),
        setSearchQueryDetail: (state, action) => {
            state.searchQueryDetail = action.payload
        },
        setSearchQueryDetailDefault: (state, action) => void(
            state.searchQueryDetail.package_id = 0,
            state.searchQueryDetail.status = ['valid', 'expired'],
            state.searchQueryDetail.statusAssign = ['unassigned', 'assigned'],
            state.searchQueryDetail.license_code = '',
            state.searchQueryDetail.nameOrEmail = '',
            state.searchQueryDetail.deployment_system_code = 'ViettelMeetingCloud'
            ),
        setSearchQueryMyUser: (state, action) => void(state.searchQueryMyUser = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
        setIsLoading: (state, action) => void(state.isLoading = action.payload),
        setNamePackage: (state, action) => void(state.namePackage = action.payload),
        setEmailCurrentActionPackage: (state, action) => void(state.emailCurrentAction = action.payload),
        setDefaultSearchQueryMyUser: (state, action) => void(
        state.searchQueryMyUser.statusArr= ['sent', 'joined'],
        state.searchQueryMyUser.typeArr=['main', 'addOns'],
        state.searchQueryMyUser.license_code= '',
        state.searchQueryMyUser.package_name='',
        state.searchQueryMyUser.nameOrEmail= ''),
        setEmailAssign: (state, action) => void(state.emailAssign = action.payload),
        setNamePackageAssign: (state, action) => void(state.namePackageAssign = action.payload),
        setLiceseCode: (state, action) => void(state.licenseCodeAssign = action.payload),
        setListAssign: (state, action) => void(state.listAssign = action.payload),
        appendListAssign: (state, action) => void(state.listAssign = [...state.listAssign, action.payload]),
        filterListAssign: (state, action) => void(state.listAssign = state.listAssign?.filter(item => item.license_code !== action.payload)),
        setIsResponse: (state, action) => void(state.isResponse = action.payload)
    }
})

export const { setLiceseCode, setEmailAssign, setNamePackageAssign, setTableData, setTableDataDetail, setSearchQuery, setSearchQueryDetail, toggleIsRefresh, setIsLoading, appendListAssign, filterListAssign, setNamePackage, setEmailCurrentActionPackage, setTableDataMyUser, setSearchQueryMyUser, setDefaultSearchQueryMyUser, setListAssign, setIsResponse, setSearchQueryDetailDefault } = packageManagementSlice.actions
export default packageManagementSlice.reducer